export default __webpack_public_path__ + "static/media/banner-default-company.45a7a736.jpeg";